import { render, staticRenderFns } from "./TransportationPlann.vue?vue&type=template&id=27587a86&scoped=true&"
import script from "./TransportationPlann.vue?vue&type=script&lang=js&"
export * from "./TransportationPlann.vue?vue&type=script&lang=js&"
import style0 from "./TransportationPlann.vue?vue&type=style&index=0&id=27587a86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27587a86",
  null
  
)

export default component.exports